import { Heart } from "lucide-react";
import { toast } from "sonner";
import { usePortalShortlist } from "@/hooks/usePortalShortlist";

const buttonVariants = {
  soft: "border-[#D4AF37]/30 bg-white text-[#8b6d16] hover:border-[#D4AF37] hover:bg-[#fff4db]",
  dark: "border-white/16 bg-[#1A1A1A] text-[#F2ECE3] hover:border-[#D4AF37]/60 hover:text-[#D4AF37]",
  outline: "border-[#001935]/12 bg-transparent text-[#42566f] hover:border-[#D4AF37]/60 hover:text-[#8b6d16]",
};

export const ShortlistActionButton = ({ listing, testId, variant = "soft" }) => {
  const { isAgentShortlistEnabled, isShortlisted, toggleListing } = usePortalShortlist();

  if (!isAgentShortlistEnabled || !listing?.id) return null;

  const active = isShortlisted(listing.id);

  return (
    <button
      className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] transition ${active ? "border-[#D4AF37] bg-[#fff4db] text-[#8b6d16]" : buttonVariants[variant] || buttonVariants.outline}`}
      data-testid={testId}
      onClick={() => {
        const added = toggleListing(listing);
        toast.success(added ? `${listing.title} saved to shortlist` : `${listing.title} removed from shortlist`);
      }}
      type="button"
    >
      <Heart className={`h-4 w-4 ${active ? "fill-current" : ""}`} />
      {active ? "Saved" : "Save"}
    </button>
  );
};